var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.19583 1.19583 0 2.66667 0H13.3333C14.8042 0 16 1.19583 16 2.66667V13.3333C16 14.8042 14.8042 16 13.3333 16H2.66667C1.19583 16 0 14.8042 0 13.3333V2.66667ZM23.2958 1.49167C23.7292 1.725 24 2.175 24 2.66667V13.3333C24 13.825 23.7292 14.275 23.2958 14.5083C22.8625 14.7417 22.3375 14.7167 21.925 14.4417L17.925 11.775L17.3333 11.3792V10.6667V5.33333V4.62083L17.925 4.225L21.925 1.55833C22.3333 1.2875 22.8583 1.25833 23.2958 1.49167Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSolid);
export default __webpack_public_path__ + "static/media/video-solid.95540de5b45ceb3ede34a18753c7e9b9.svg";
export { ForwardRef as ReactComponent };